import PDFreport from './images/PDFreport.svg';

const PDFReport = () => {
    return <img src={PDFreport} alt="Example PDF Report"></img>;
};

export default PDFReport;
